
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.999 3.5c1.657 0 3 1.384 3 3.091V12c0 1.707-1.343 3.091-3 3.091-1.656 0-3-1.384-3-3.091V6.591c0-1.707 1.344-3.091 3-3.091zm.751 14.634v.821H15V20.5H9v-1.545h2.25v-.821C8.29 17.754 6 15.152 6 12v-1.546h1.5V12c0 2.56 2.015 4.636 4.5 4.636S16.5 14.56 16.5 12v-1.546H18V12c0 3.152-2.29 5.754-5.25 6.134zM10.502 6.591c0-.853.671-1.545 1.5-1.545.828 0 1.5.692 1.5 1.545V12c0 .854-.672 1.546-1.5 1.546-.829 0-1.5-.692-1.5-1.546V6.591z"}})])
          )
        }
      }
    